/**
 * @generated SignedSource<<adb4b2212dee9be3b43f855a7f0acdb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RecoveryCodeList_recoveryCodes$data = {
  readonly codes: ReadonlyArray<{
    readonly code: string;
    readonly consumed: boolean;
  }>;
  readonly " $fragmentType": "RecoveryCodeList_recoveryCodes";
};
export type RecoveryCodeList_recoveryCodes$key = {
  readonly " $data"?: RecoveryCodeList_recoveryCodes$data;
  readonly " $fragmentSpreads": FragmentRefs<"RecoveryCodeList_recoveryCodes">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RecoveryCodeList_recoveryCodes",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RecoveryCode",
      "kind": "LinkedField",
      "name": "codes",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "code",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "consumed",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecoveryCodeBatch",
  "abstractKey": null
};

(node as any).hash = "98a7688591ffb00960f4b4acc49ca216";

export default node;
